import { Form, Col, Row, Button } from "react-bootstrap";
import { useState } from "react";
import { FECHA_TEST_DRIVE } from "./constants";
import {
  INITIAL_FORM,
  INITIAL_TOUCHED,
  INITIAL_ERRORS,
  validateField,
  isFormValid,
  getInputClass,
} from "./formValidation";

const FormularioRanger = ({ loading, onSubmit, config }) => {
  const [validated, setValidated] = useState(false);
  const [honeypot, setHoneypot] = useState("");
  const [contact, setContact] = useState(INITIAL_FORM);
  const [touched, setTouched] = useState(INITIAL_TOUCHED);
  const [focus, setFocus] = useState(INITIAL_TOUCHED);
  const [errors, setErrors] = useState(INITIAL_ERRORS);

  const handleBlur = (field) => {
    setTouched((t) => ({ ...t, [field]: true }));
    setFocus((f) => ({ ...f, [field]: false }));
    setErrors((e) => ({ ...e, [field]: validateField(field, contact[field]) }));
  };

  const handleFocus = (field) => {
    setFocus((f) => ({ ...f, [field]: true }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;

    if (name === "phone" || name === "dni") {
      processedValue = value.replace(/\D/g, "");
    }

    setContact((c) => ({ ...c, [name]: processedValue }));
    setErrors((err) => ({ ...err, [name]: validateField(name, processedValue) }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    onSubmit({
      ...contact,
      fecha: FECHA_TEST_DRIVE.value,
      marcaSeleccionada: "GAC Aion UT",
      tipoFormulario: "aion-ut",
    });
  };

  const formIsValid = isFormValid(contact, errors);

  return (
    <div className="formulario-ranger">
      <div className="formulario-titulo formulario-titulo--ranger">
        <h2 className="formulario-titulo__heading">
          <span className="formulario-titulo__inscripcion">Test Drive</span>
          <span className="formulario-titulo__sep" aria-hidden="true">
            |
          </span>
          <span className="formulario-titulo__evento">{config.eventName}</span>
        </h2>
        <p className="formulario-titulo__subtitulo">{config.introSubtitle}</p>
      </div>

      <Form onSubmit={handleSubmit} noValidate validated={validated}>
        <input
          type="text"
          name="hidden_field"
          style={{ display: "none" }}
          value={honeypot}
          onChange={(e) => setHoneypot(e.target.value)}
          tabIndex={-1}
          autoComplete="off"
        />

        <Row className="g-3 mb-1">
          <Col md={6}>
            <Form.Group controlId="nombre">
              <Form.Label className="fw-bold">
                Nombre <span className="asterisco-ford">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="nombre"
                required
                placeholder="Ingresá tu nombre"
                value={contact.nombre}
                onChange={handleChange}
                onBlur={() => handleBlur("nombre")}
                onFocus={() => handleFocus("nombre")}
                className={`form-input form-input--ford ${getInputClass("nombre", contact.nombre, { errors, touched, focus })}`}
              />
              {errors.nombre && touched.nombre && <div className="error-feedback">{errors.nombre}</div>}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="apellido">
              <Form.Label className="fw-bold">
                Apellido <span className="asterisco-ford">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="apellido"
                required
                placeholder="Ingresá tu apellido"
                value={contact.apellido}
                onChange={handleChange}
                onBlur={() => handleBlur("apellido")}
                onFocus={() => handleFocus("apellido")}
                className={`form-input form-input--ford ${getInputClass("apellido", contact.apellido, { errors, touched, focus })}`}
              />
              {errors.apellido && touched.apellido && <div className="error-feedback">{errors.apellido}</div>}
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group controlId="email">
              <Form.Label className="fw-bold">
                E-mail <span className="asterisco-ford">*</span>
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                required
                placeholder="ejemplo@correo.com"
                value={contact.email}
                onChange={handleChange}
                onBlur={() => handleBlur("email")}
                onFocus={() => handleFocus("email")}
                className={`form-input form-input--ford ${getInputClass("email", contact.email, { errors, touched, focus })}`}
              />
              {errors.email && touched.email && <div className="error-feedback">{errors.email}</div>}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="phone">
              <Form.Label className="fw-bold">
                Nro. de celular <span className="asterisco-ford">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="phone"
                required
                placeholder="Ej: 351 2345-6789"
                value={contact.phone}
                onChange={handleChange}
                onBlur={() => handleBlur("phone")}
                onFocus={() => handleFocus("phone")}
                className={`form-input form-input--ford ${getInputClass("phone", contact.phone, { errors, touched, focus })}`}
                onInput={(e) => (e.currentTarget.value = e.currentTarget.value.replace(/\D/g, ""))}
                minLength={10}
                maxLength={10}
              />
              {errors.phone && touched.phone && <div className="error-feedback">{errors.phone}</div>}
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="dni">
              <Form.Label className="fw-bold">
                DNI <span className="asterisco-ford">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="dni"
                required
                placeholder="Ingresá tu número de documento"
                value={contact.dni}
                onChange={handleChange}
                onBlur={() => handleBlur("dni")}
                onFocus={() => handleFocus("dni")}
                className={`form-input form-input--ford ${getInputClass("dni", contact.dni, { errors, touched, focus })}`}
                onInput={(e) => (e.currentTarget.value = e.currentTarget.value.replace(/\D/g, ""))}
                minLength={7}
                maxLength={8}
              />
              {errors.dni && touched.dni && <div className="error-feedback">{errors.dni}</div>}
            </Form.Group>
          </Col>
        </Row>

        <p className="ranger-legal mt-4">
          Al hacer clic en el botón, acepto la Política de Privacidad de GAC Argentina y autorizo al tratamiento y la
          cesión de mis datos para que me contacten por WhatsApp con publicidad y promociones de GAC Argentina.
        </p>

        <div className="pt-2 pb-4">
          <Button type="submit" className="btn-ford w-100" disabled={!formIsValid || loading}>
            {loading ? "Enviando…" : "Reservar test drive"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FormularioRanger;
